<template>
  <div class="blog-page">
    <HeroSection
      v-model:searchQuery="searchQuery"
      :title="heroTitle"
      :subtitle="heroSubtitle"
      :searchLabel="searchLabel"
      :titleMessage="titleMessage"
      :showTitleMessage="true"
      :showBannerImage="true"
      :bannerImageMobile="bannerImageMobile"
      :bannerImage="bannerImage"
      :heroSubtitleMob="heroSubtitleMob"
    />
    <BlogListSection
      :searchQuery="searchQuery"
      :items="allBlogs"
      :status="status"
      :filters="filters"
      :activeFilter="activeFilter"
      v-model:page="page"
      :totalItems="totalBlogs"
      :limit="limit"
      :showFilters="false"
      :cardComponent="BlogCard"
      :setFilter="setFilter"
      :fetchItems="fetchBlogs"
      :routePath="routePath"
      :showReadTime="false"
      @clearSearchInput="clearSearchInput"
      :notFoundTitle="notFoundTitle"
      :notFoundHint="notFoundHint"
    />
    <Newsletter />
    <GetInTouch :backgroundColor="'#DEF3FF'" />
  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted } from 'vue';
import LearninghubService from '@/services/API/learninghubService';
import HeroSection from '../partials/HeroSection.vue';
import BlogListSection from '../partials/CardListSection.vue';
import Newsletter from '../partials/Newsletter.vue';
import GetInTouch from './../../service/components/GetInTouch.vue';
import GenericCard from '../partials/Card.vue';

const BlogCard = GenericCard; // Alias for clarity

const searchQuery = ref('');
const heroTitle = ref('Learning Hub');
const titleMessage = ref('Discover, Learn, and Grow with DIGU.');
const heroSubtitle = ref(
  'The Learning Hub is your go-to destination for expert-led sessions, workshops, and </br> webinars—designed to upskill professionals, empower teams, and </br> explore what’s next in tech, identity, and innovation.'
);
const heroSubtitleMob = ref(
  'The Learning Hub is your go-to destination for expert-led sessions, workshops, and webinars—designed to upskill professionals, empower teams, and explore what’s next in tech, identity, and innovation.'
);
const searchLabel = ref('Search webinars, workshops, and expert-led sessions');
const routePath = ref('/learning-hub'); // Define the route path

const notFoundTitle = ref('No sessions found'); // Custom title
const notFoundHint = ref(
  'We couldn’t find any events or learning resources matching your search.Try a different keyword or explore all webinars, workshops, and expert sessions.'
);

const allBlogs = ref([]);
const bannerImage = 'learninghub-banner-desktop.svg';
const bannerImageMobile = 'Learninghub-banner-mobile.svg';
const status = ref('loading');
const activeFilter = ref('all');
const page = ref(1);
const totalBlogs = ref(0);
const limit = 12;
const filters = ref([
  { id: 'all', label: 'All Posts' },
  { id: 'Webinar', label: 'Webinar' },
  { id: 'Workshop', label: 'Workshops' },
  { id: 'Session', label: 'Expert-led Sessions' },
]);

const totalPages = computed(() => Math.ceil(totalBlogs.value / limit));

const fetchLearninghubs = async (key = searchQuery.value) => {
  try {
    status.value = 'loading';
    const res = await LearninghubService.listAllLearninghub(
      activeFilter.value,
      key,
      page.value - 1
    );
    if (res.status === 200) {
      allBlogs.value = res.data.data;
      totalBlogs.value = res.data.total;
    } else {
      allBlogs.value = [];
    }
    status.value = 'success';
  } catch (e) {
    status.value = 'error';
    console.log(e);
  }
};

const setFilter = (filterId) => {
  activeFilter.value = filterId;
  page.value = 1;
  fetchLearninghubs();
};

const clearSearchInput = () => {
  searchQuery.value = '';
};

watch(searchQuery, async (newKey) => {
  await fetchLearninghubs(newKey);
  page.value = 1;
});

watch(page, async () => {
  await fetchLearninghubs();
});

onMounted(async () => {
  await fetchLearninghubs();
});
</script>
